// SPDX-License-Identifier: AGPL-3.0-or-later

import {openOAuthAuthorizeModalFromUrl} from '@app/features/auth/commands/OAuthAuthorizeModalCommands';
import {openExternalUrl} from '@app/features/ui/utils/NativeUtils';

/**
 * Opens a link that leaves the app. Konvo is a single-organisation deployment, so
 * external links open straight away; only our own OAuth authorize URLs are kept
 * in-app, where they belong.
 */
export function openExternalLink(url: string): void {
	if (openOAuthAuthorizeModalFromUrl(url)) return;
	void openExternalUrl(url);
}
